import { useTokenPermissions } from "./useTokenPermissions";
import { TokenPermissionModule } from "../constants/permissions";

export function useCalendarTokenPermissions() {
  const { canView, canEdit, canAccess } = useTokenPermissions();

  const canViewCalendar = (): boolean => {
    return canView(TokenPermissionModule.CALENDAR);
  };

  const canEditCalendar = (): boolean => {
    return canEdit(TokenPermissionModule.CALENDAR);
  };

  const canAccessCalendar = (): boolean => {
    return canAccess(TokenPermissionModule.CALENDAR);
  };

  return {
    canViewCalendar,
    canEditCalendar,
    canAccessCalendar,
  };
}
